
<template>
  <div class="lessonShare">
    <slot name="lessonShare"></slot>
  </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>
.lessonShare {
  background: #FFC44E;
  color: #FFFFFF;
}
.lessonShare a{
  color: #FFFFFF;
  display: block
}
</style>